// Accordion
$(function(){
  //.accordion_oneの中の.accordion_headerがクリックされたら
  $('.s_03 .accordion_one .accordion_header').click(function(){
    //クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
    $(this).next('.accordion_inner').slideToggle();
    $(this).toggleClass("open");
  });
});

//Top Sellection
$(function(){
  const target1 = $('#shopify-section-collection-list').find('#top-sellection-ttl');
  const target2 = $('#shopify-section-16046273913227e3a4').find('#top-sellection-ttl');
  const target3 = $('#shopify-section-collection-list').find('#top-sellection-subttl');
  const target4 = $('#shopify-section-16046273913227e3a4').find('#top-sellection-subttl');
  
  target1.html("素材・ジャンルから選ぶ");
  target2.html("利用シーンから選ぶ");
  target3.html("自分好みから選ぶ「とっておき」の逸品");
  target4.html("ほっとするシーンを彩る「とっておき」の逸品");
});


//Shopping cart Button
theme.backButton = function() {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
    var    a      = "https://www.washokuto.jp/"

    a.href = url;
    return a.hostname;
  }
};

